module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button grey",
    attrs: {
      "to": {
        path: '/plates/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Rendszám")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "owner_name",
      "label": "Tulajdonos neve",
      "errors": _vm.errors,
      "name": "owner_name",
      "disabled": ""
    },
    model: {
      value: (_vm.form.owner_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "owner_name", $$v)
      },
      expression: "form.owner_name"
    }
  }), _vm._v(" "), (_vm.up_email != '') ? _c('inputbox', {
    attrs: {
      "disabled": "",
      "id": "up_email",
      "label": "E-mail cím",
      "name": "up_email"
    },
    model: {
      value: (_vm.up_email),
      callback: function($$v) {
        _vm.up_email = $$v
      },
      expression: "up_email"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.email != '') ? _c('inputbox', {
    attrs: {
      "disabled": "",
      "id": "email",
      "label": "E-mail cím",
      "name": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }) : _vm._e(), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "card_number",
      "label": "Kártyaszám",
      "errors": _vm.errors,
      "name": "card_number",
      "disabled": ""
    },
    model: {
      value: (_vm.form.card_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "card_number", $$v)
      },
      expression: "form.card_number"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "number",
      "label": "Rendszám",
      "errors": _vm.errors,
      "name": "number"
    },
    model: {
      value: (_vm.form.number),
      callback: function($$v) {
        _vm.$set(_vm.form, "number", $$v)
      },
      expression: "form.number"
    }
  }), (_vm.form.active_season_ticket) ? _c('i', {
    staticClass: "fa fa-exclamation-circle fa-lg",
    staticStyle: {
      "color": "#C25450"
    }
  }, [_c('span', {
    staticStyle: {
      "padding": "2px",
      "font-family": "'Open Sans'"
    }
  }, [_vm._v("Bérlethez rendelt rendszám.")])]) : _vm._e()], 1)])])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a2e517a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/plate.vue
// module id = 317
// module chunks = 0